import actionTypes from '../../actions/actionTypes'
import { fromJS } from 'immutable';
import { PROGRAM_DEFAULT } from '../../constants/state';
import { returnStateIfNoAction } from '../helpers';

const INIT_STATE = fromJS(PROGRAM_DEFAULT.attributes)


const update = (state, action) => fromJS(action.payload.dataAttributes)

function attributesReducer(state = INIT_STATE, action) {
    
    returnStateIfNoAction(action, state)

    switch(action.type){
        case actionTypes.ATTRIBUTES_UPDATE:
            return update(state, action)
        default:
            return state;
    }
}

export default attributesReducer